import { useEffect, useState } from "react";
import { fetchJson } from "../fetch.js";
import * as Helpers from '../helpers.mjs';
import AddToBasket from './AddToBasket.js';
import OrderTrackIcons from './OrderTrackIcons.js';
import OfferLink from './OfferLink.js';
import BulkDiscountsTable from './BulkDiscountsTable.js';
import { useElasticData, useExtraData } from "./DataContext.js";

const BookPackControls = () => {
    let { elasticData, product } = useElasticData();
    let { extraData, isGuestUser, isSchoolsUser, isForSchoolBasket } = useExtraData(); 

    const pds = elasticData;
    const productEan13 = pds.id;
    const [productPrice, setProductPrice] = useState(0);
    const hasMaxPrice = (pds.max_price != null && pds.max_price != pds.min_price);
    const [productRrp, setProductRrp] = useState(0);
    const [bookPackPriceSlider, setBookPackPriceSlider] = useState(false);
    const stepValueInit = pds.increment ?? 10;
    let stepValue = stepValueInit;
    let productDiscount = pds.discount;
    const isStandardBookPack = (!pds.primary_candidates || pds.primary_candidates?.length == 0);
    const hasBookCount = (pds.total_books !== null);

    useEffect(() => {
        fetchJson("/product/checkFeatureFlag/book_pack_price_slider").then(r => {
            setBookPackPriceSlider(r);
        });
    }, []);

    useEffect(() => {
        updateBookPackDetails(pds.min_price, productDiscount);
    }, [productEan13]);

    if (!extraData) {
        return null;
    }

    let orderedBefore = extraData.orderedBefore;
    let isForSchoolBasketRes = isForSchoolBasket();
    let isSchoolUserRes = Helpers.isSchoolUser();

    var offerLink = null;
    if (isSchoolUserRes || isForSchoolBasketRes) {
        if (extraData.offerPage != null) {
            offerLink = <OfferLink link={"/" + extraData.offerPage} heading="Special offer" name={extraData.offerGroupName} ofid={extraData.offerGroupId} />
        } else if (extraData.offerTiers && extraData.offerTiers.length > 1) {
            offerLink = <BulkDiscountsTable tiers={extraData.offerTiers} />
        } else if (extraData.offerMinQuantity > 1) {
            offerLink = <OfferLink link={null} heading="Class set offer" name={`Order ${extraData.offerMinQuantity} or more copies of this title and get ${extraData.offerDiscount}% off the RRP`} ofid={extraData.offerGroupId} />
        } else if (extraData.offerGroupName) {
            offerLink = <OfferLink link={null} heading="Special offer" name={extraData.offerGroupName} ofid={extraData.offerGroupId} />
        }
    }

    function updateBookPackDetails(price, discount) {
        setProductPrice(price);
        let bookPackRrpCalculation = (price / (1 - discount));
        setProductRrp(bookPackRrpCalculation);
        if (isStandardBookPack && hasMaxPrice && hasBookCount) {
            const averageBookPrice = Number(pds.min_price / pds.total_books).toFixed(2);
            const newApproxBooksCount = Number(price / averageBookPrice).toFixed(0);
            $('p.needMore.approxBooks').find('span').html(`This pack contains approximately ${newApproxBooksCount} books.`);
        }
    }

    return (
        <div className="deliveryInfo">
            <h3 className="bookPrice">{Intl.NumberFormat('en-UK', { style: 'currency', currency: 'GBP' }).format(productPrice)}</h3>
            <div className="pricingBreakdown">
                <p className="rrp">
                    <strong>RRP&nbsp;{Intl.NumberFormat('en-UK', { style: 'currency', currency: 'GBP' }).format(productRrp)}</strong>
                    {productDiscount > 0 && <span className="savingPercent">{Intl.NumberFormat("en-GB", { style: "percent", minimumFractionDigits: 2, maximumFractionDigits: 2}).format(productDiscount)}</span>}
                </p>
            </div>

            {orderedBefore && <div className="pricingBreakdown">
                <a href={`/isbn?isbn=${pds.id}`} target="_blank"><i style={{ color: '#ff006d' }} className="fas fa-shopping-basket" title="This title has been ordered before, or is currently in another basket"></i></a>
            </div>}
            {!isGuestUser && isSchoolsUser && <div className="stockSection">Available</div>}
            {isStandardBookPack
                ? <input className="bookQuantity productQty" type="hidden" value={1} />
                : <div className="quantitySection">
                    <p>Quantity&nbsp;<input className="bookQuantity productQty" type="number" max="999" defaultValue={1} placeholder="0" maxLength={3} min={1} /></p>
                  </div>
            }
            {hasMaxPrice && bookPackPriceSlider && <div className="bookPackValueSlideContainer">
                <div className="pricingBreakdown">
                    <p className="needMore">
                        <strong>Customise my pack&nbsp;<i className="fas fa-info-circle"></i></strong>
                        <span className="searchToolTip">Want to add extra books on the same theme or topic? Drag the slider to the right to select the amount you would like to spend on this pack.</span>
                    </p>
                    <p>Increase the number of books you will receive</p>
                </div>
                <input type="range" onChange={e => {
                    let max = Number(e.target.max); 
                    let min = Number(e.target.min);
                    let rv = max - min
                    let d = max - (rv % stepValue);
                    let v = Number(e.target.value);
                    updateBookPackDetails(e.target.value, productDiscount);
                    if (v >= d) {
                        let steps = rv/stepValueInit;
                        stepValue = rv/Math.round(steps);
                    } else {
                        stepValue = stepValueInit;
                    }
                    e.target.step = stepValue;
                }} min={pds.min_price} max={pds.max_price} step={stepValue} value={productPrice} id="bookPackValueRange" />
                <p className="sliderNumbers">
                    <span className="min">{Intl.NumberFormat('en-UK', { style: 'currency', currency: 'GBP' }).format(pds.min_price)}</span>
                    <span className="max">{Intl.NumberFormat('en-UK', { style: 'currency', currency: 'GBP' }).format(pds.max_price)}</span>
                </p>
            </div>}
            <AddToBasket product={product} hit={elasticData} isBookPack={isStandardBookPack} />
            {offerLink !== null && <div className="offerDetails offerDetailsBookPage">
                {offerLink}
            </div>}
            <OrderTrackIcons />

            
        </div>
    );
}

export default BookPackControls;
